export type FnpSortDirection = 'asc' | 'desc'

export interface FnpSortConfig {
  key: string
  direction: FnpSortDirection
  secondary?: FnpSortConfig
}

export function getDefaultFnpSort(showMonthColumn: boolean): FnpSortConfig {
  if (showMonthColumn) {
    return {
      key: 'report_month',
      direction: 'asc',
      secondary: { key: 'amount_excl_vat', direction: 'desc' },
    }
  }
  return { key: 'amount_excl_vat', direction: 'desc' }
}

export function fnpSortConfigKey(sort: FnpSortConfig): string {
  const secondary = sort.secondary
    ? `|${sort.secondary.key}:${sort.secondary.direction}`
    : ''
  return `${sort.key}:${sort.direction}${secondary}`
}

export function fnpSortConfigToQueryParams(sort: FnpSortConfig): Record<string, string> {
  const params: Record<string, string> = {
    sort_key: sort.key,
    sort_dir: sort.direction,
  }
  if (sort.secondary) {
    params.sort_secondary_key = sort.secondary.key
    params.sort_secondary_dir = sort.secondary.direction
  }
  return params
}
